/**
 * Two small storefront behaviours migrated out of the XO Insert Code app, where they lived as
 * inline <script> tags in the app's header block. Moving them here puts them under version
 * control and lets the app be uninstalled.
 *
 * Ported as-is on 2026-09-17 — same logic, same selectors, same thresholds. Deliberately not
 * "improved" while migrating: a behaviour change hidden inside a move is the hardest kind of
 * regression to trace back.
 *
 * Ticket: [CONFIG] XO Insert Code cleanup
 */

/**
 * Superscript the ™ and ® marks.
 *
 * The brand uses "Manhattan Toy™" throughout, and the marks render at full size unless they are
 * wrapped. This walks the text nodes and replaces each mark with a 50%-size superscript span.
 *
 * Note for whoever touches this next: the walker keeps its position while the text node it just
 * returned is being replaced. That is how it ran in the app, so it stays that way here; if a mark
 * ever appears unstyled next to one that is styled, this is the first place to look.
 */
document.addEventListener('DOMContentLoaded', function () {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  let node;

  while ((node = walker.nextNode())) {
    const text = node.nodeValue;
    if (!text || (!text.includes('™') && !text.includes('®'))) continue;

    const parent = node.parentNode;
    if (!parent) continue;

    const frag = document.createDocumentFragment();

    for (const char of text) {
      if (char === '™' || char === '®') {
        const span = document.createElement('span');
        span.style.fontSize = '50%';
        span.style.verticalAlign = 'super';
        span.textContent = char;
        frag.appendChild(span);
      } else {
        frag.appendChild(document.createTextNode(char));
      }
    }

    parent.replaceChild(frag, node);
  }
});

/**
 * Eager-load the images that start inside the viewport.
 *
 * The theme lazy-loads images by default, which costs LCP on whatever is above the fold. This
 * promotes those to loading="eager" + fetchpriority="high" once the DOM is ready.
 */
document.addEventListener('DOMContentLoaded', function () {
  const viewportH = window.innerHeight || 0;

  document.querySelectorAll('img').forEach((img) => {
    if (!img || img.getAttribute('loading') === 'eager') return;

    const rect = img.getBoundingClientRect();
    if (rect.top >= 0 && rect.top < viewportH) {
      img.setAttribute('loading', 'eager');
      img.setAttribute('fetchpriority', 'high');
    }
  });
});
